import React from "react";
import { AiOutlineArrowDown, AiOutlineArrowUp } from "react-icons/ai";
import Loader from "react-loader-spinner";
import { TableHeader } from "../table/TableHeader";
import { useState, useEffect } from "react";
import Utils from "../../utils/Utils";
import Link from "next/link";
import Lock from "../Lock";
import Image from "next/image";
import { getDefYear } from "../../constants/main";
const TableData = ({ data, header, user, tableTitle, league = "", children = null, perPageRec = 10 }) => {
  const [gameToShow, setGameToShow] = useState([]);
  const [slicedArray, setSlicedArray] = useState([]);
  const [slicedArrayIndex, setSlicedArrayIndex] = useState(0);
  const [sortedKey, setSortedKey] = useState("");
  const [ascOrder, setAscOrder] = useState(true);
  const [showLoadMoreButton, setShowLoadMoreButton] = useState(false);

  const isPaid = user?.has_paid;

  useEffect(() => {
    setGameToShow(data);
  }, [data]);

  useEffect(() => {
    if (gameToShow) {
      setSlicedArray(gameToShow.slice(0, slicedArrayIndex + perPageRec));
      if (gameToShow.length > slicedArrayIndex + perPageRec) {
        setShowLoadMoreButton(true);
      } else {
        setShowLoadMoreButton(false);
      }
    }
  }, [slicedArrayIndex, gameToShow]);

  const sort = (key) => {
    let res = [];
    let rawData = [...gameToShow];
    let replaceKey;
    const headerObj = header.filter((column) => column["key"] === key)[0];
    replaceKey = headerObj["key"];

    // if (key === "play") {
    //   replaceKey = "Points of Value";
    // }

    let keySumm = {};

    if (key === "Projected (Home)" && columnType == "defen") {
      replaceKey = "summaryColumns";
      keySumm["key1"] = "Projected Home Score";
      keySumm["key2"] = "Projected Away Score";
    }
    if (sortedKey === key) {
      let order = ascOrder ? "asc" : "desc";
      res = rawData.sort(Utils.dynamicsort(replaceKey, order, keySumm));
      // ascOrder = order === "desc";
      setAscOrder(!ascOrder);
    } else {
      // ascOrder = false;
      setAscOrder(false);
      setSortedKey(key);
      res = rawData.sort(Utils.dynamicsort(replaceKey, null, keySumm));
    }
    setGameToShow([...res]);
  };

  const handleLoadMore = () => {
    setSlicedArrayIndex(slicedArrayIndex + perPageRec);
  };

  return (
    <>
      <div className="table-responsive low-padding mt-5">
        <h2 className="text-center">
          <u>{tableTitle}</u>
        </h2>
        <table className="table">
          <thead>
            <tr className="text-center header-container-table">
              <TableHeader headers={header} onSortClick={sort} ascOrder={ascOrder} sortedKey={sortedKey} />
            </tr>
          </thead>
          <tbody>
            {gameToShow.length > 0 ? (
              <>
                {slicedArray.map((data, index) => {
                  return <TableRow key={index} data={data} header={header} isPaid={isPaid} league={league} />;
                })}
                {children}
              </>
            ) : null}

            {!slicedArray.length & user ? (
              <div className="loader mt-5">
                <Loader type={"Oval"} visible color={"orange"} height={60} width={60} />
                Loading...
              </div>
            ) : null}
          </tbody>
        </table>
      </div>
      <div className="text-center mt-1">
        {showLoadMoreButton && (
          <button className="btn btn-primary" onClick={handleLoadMore}>
            Load More..
          </button>
        )}
      </div>
    </>
  );
};

export const TableRow = ({ data, header, isPaid, league }) => {
  const year = getDefYear(league);
  const getLink = (column, value) => {
    let refLink = "";
    if (column.linkTo === "home") {
      refLink = "/";
    } else if (column.linkTo === "gamePage") {
      refLink = `/game/${league}/${year}/${data?.team || data?.home}/${data?.date} ${data?.team || data?.home} ${
        data?.opponent || data?.away
      }`;
    } else if (column.linkTo === "opponentPage") {
      refLink = `/team/${league}/${year}/${data?.opponent || data?.away || data?.away_team}`;
    } else if (column.linkTo === "homeTeamPage") {
      refLink = `/team/${league}/${year}/${data?.team || data?.home || data?.home_team}`;
    } else if (column.linkTo === "matchup") {
      refLink = `/${league}/matchup-output/${data?.team || data?.home || data?.home_team}/${
        data?.opponent || data?.away || data?.away_team
      }/false`;
    }
    if (column?.logoKey && refLink) {
      return (
        <Link href={refLink} style={{ display: "inline-block" }}>
          <span>
            <Image
              height={30}
              width={30}
              src={`http://shotqualitybets.com/static/media/logos/${value}.png`}
              alt={""}
              className="img-fluid w-25 pull-left GameCard__team--logo logo-left2"
            />
            &nbsp; {value}
          </span>
        </Link>
      );
    } else if (refLink) {
      return <Link href={refLink}>{value}</Link>;
    }
    return value;
  };
  return (
    <tr>
      {header.map((column, index) => {
        let value = data[column.key] === null ? "-" : data[column.key];
        const isFloatNumber = typeof value === "number" && value % 1 !== 0;
        value = isFloatNumber ? value.toFixed(2) : value;
        const showArrow = column?.showArrow || false;
        const isLink = column?.linkTo || false;

        if (value?.toString()?.includes("NaN") || value?.toString()?.includes("NA%")) {
          value = "-";
        }
        if (showArrow) {
          value = <WithArrowLogic value={value} />;
        }

        return isPaid || column?.lock !== true ? (
          <td className="text-center" key={"paid-td" + index}>
            {/* {isLink ? <Link href={getLink(column.linkTo)}>{value}</Link> : value} */}
            {isLink ? getLink(column, value) : value}
          </td>
        ) : (
          <td className="text-center" key={"paid-td" + index}>
            <TableHeader headers={SQLock} />
          </td>
        );
      })}
    </tr>
  );
};

const WithArrowLogic = ({ value }) => {
  if (value === "-") {
    return "-";
  }
  let val = Number((value + "").replaceAll("%", "")) || 0;
  return (
    <span>
      {val > 0 ? (
        <AiOutlineArrowUp color="#208502" className="arrow up" />
      ) : val < 0 ? (
        <AiOutlineArrowDown color="#D82011" className="arrow down" />
      ) : (
        ""
      )}{" "}
      {value}
    </span>
  );
};
const SQLock = [
  {
    title: Lock,
    showImage: false,
    sortable: false,
    key: "88-88",
    classList: ["dummyLockToolTip"],
    tooltip: {
      title: "Only available to ShotQuality Subscribers",
      text: "Available to existing ShotQuality Bets members. New memberships are no longer available.",
      link: "/login",
    },
  },
];

export default TableData;
